module.exports = __webpack_public_path__ + "static/media/TR.28b8c158.svg";